import {Component, Input} from '@angular/core';
import {YearlyYield} from '../../utils/yield.utils';

@Component({
    selector: 'app-yearly-yield-list',
    templateUrl: './yearly-yield-list.component.html',
    styleUrls: ['./yearly-yield-list.component.css'],
    standalone: false
})
export class YearlyYieldListComponent {

  @Input()
  entries: YearlyYield[] = [];

  @Input()
  title = 'Ertrag pro Jahr';

  get hasEntries(): boolean {
    return !!this.entries && this.entries.length > 0;
  }
}
